var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { ref: "paginationElem", staticClass: "dynamic-tabs-pagination" },
    [
      _c(
        "ol",
        { staticClass: "dynamic-tabs-pagination-items" },
        [
          _vm.currentPage > 1
            ? _c("li", [
                _c(
                  "span",
                  {
                    staticClass: "dynamic-tabs-pagination-label",
                    on: { click: _vm.prev }
                  },
                  [_vm._v("\n        " + _vm._s(_vm.prevLabel) + "\n      ")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.first
            ? _c("li", [
                _c("a", { on: { click: _vm.onClickFirst } }, [
                  _vm._v("\n        " + _vm._s(_vm.first.title) + "\n      ")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.pageOffset > 0
            ? _c("li", [
                _c("a", { on: { click: _vm.decreaseOffset } }, [
                  _vm._v("\n        ...\n      ")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.pages, function(page) {
            return _c("li", { key: page.url }, [
              _c(
                "a",
                {
                  class: { "is-current": page.isCurrent },
                  on: {
                    click: function($event) {
                      return _vm.$emit("change-page", page.title)
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(page.title) + "\n      ")]
              )
            ])
          }),
          _vm._v(" "),
          _vm.pageCount > 5 && _vm.last
            ? _c("li", [
                _c("a", { on: { click: _vm.increaseOffset } }, [
                  _vm._v("\n        ...\n      ")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.last
            ? _c("li", [
                _c("a", { on: { click: _vm.onClickLast } }, [
                  _vm._v("\n        " + _vm._s(_vm.last.title) + "\n      ")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.currentPage !== _vm.pageCount
            ? _c("li", [
                _c(
                  "span",
                  {
                    staticClass: "dynamic-tabs-pagination-label",
                    on: { click: _vm.next }
                  },
                  [_vm._v("\n        " + _vm._s(_vm.nextLabel) + "\n      ")]
                )
              ])
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }